import { render, staticRenderFns } from "./r-piggy-stage-config-dialog.vue?vue&type=template&id=35bdf914&scoped=true"
import script from "./r-piggy-stage-config-dialog.vue?vue&type=script&lang=js"
export * from "./r-piggy-stage-config-dialog.vue?vue&type=script&lang=js"
import style0 from "./r-piggy-stage-config-dialog.vue?vue&type=style&index=0&id=35bdf914&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35bdf914",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35bdf914')) {
      api.createRecord('35bdf914', component.options)
    } else {
      api.reload('35bdf914', component.options)
    }
    module.hot.accept("./r-piggy-stage-config-dialog.vue?vue&type=template&id=35bdf914&scoped=true", function () {
      api.rerender('35bdf914', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/smart-offer/bundle-piggy/r-piggy-stage-config-dialog.vue"
export default component.exports